import type { Mission } from '../missions.ts'

export const frb: Mission = {
  id: "frb",
  name: "Board of Governors of the Federal Reserve System",
  short: "Federal Reserve",
  kind: "independent",
  community: "financial",
  url: "https://www.federalreserve.gov/",
  established: 1913,
  palette: {
    primary: "#163855",
    secondary: "#3a6c9c",
    accent: "#cf8b40",
  },
  colorSource: {
    kind: "site",
    url: "https://www.federalreserve.gov/",
  },
  motif: "eagle",
  mission: {
    text: "The Federal Reserve System is the central bank of the United States. It performs five general functions to promote the effective operation of the U.S. economy and, more generally, the public interest.",
    url: "https://www.federalreserve.gov/aboutthefed.htm",
  },
  fact: {
    text: "The Federal Reserve Act of 1913 established the Federal Reserve System as the central bank of the United States.",
    url: "https://www.federalreserve.gov/aboutthefed/fract.htm",
  },
  seal: {
    file: "public/seals/frb.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Reserve_Board.svg",
  },
  identifier: {
    about: "https://www.federalreserve.gov/aboutthefed.htm",
    accessibility: "https://www.federalreserve.gov/accessibility.htm",
    foia: "https://www.federalreserve.gov/foia/about_foia.htm",
    noFear: "https://www.federalreserve.gov/eeo.htm",
    oig: "https://oig.federalreserve.gov/",
    performance: "https://www.federalreserve.gov/publications/annual-report.htm",
    privacy: "https://www.federalreserve.gov/privacy.htm",
  },
  media: {
    photos: [
      {
        file: "/media/frb-eccles-autumn.jpg",
        small: "/media/frb-eccles-autumn-sm.jpg",
        alt: "The white marble Marriner S. Eccles Building framed by autumn trees under a blue sky",
        title: "Marriner S. Eccles Building",
        creator: "Board of Governors of the Federal Reserve System",
        source: "https://commons.wikimedia.org/wiki/File:Ec_05_(26114196145).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/frb-eccles-atrium.jpg",
        small: "/media/frb-eccles-atrium-sm.jpg",
        alt: "Marble atrium of the Eccles Building with twin staircases beneath an eagle skylight",
        title: "Marriner S. Eccles Building atrium",
        creator: "Board of Governors of the Federal Reserve System",
        source: "https://commons.wikimedia.org/wiki/File:EA_033105_AT_1191_(26114334815).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
